/**
 * @author Sirisha.M
 * @description 
 */
import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import React, { useState, useEffect, useCallback, useRef, Fragment } from 'react';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const CompassGuage = (props) => {
  const getOption = useCallback(() => {
    let { graphprops } = props;
    return {
      progress: {
        show: true,
        overlap: false,
        roundCap: true,
        clip: false,
        itemStyle: {
          borderWidth: 1,
          borderColor: '#464646'
        }
      },
      toolbox: {
        showTitle: true,
        itemSize: 25,
        feature: {
          saveAsImage: {
            // backgroundColor: "black",
            title: 'download',
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            name: graphprops && graphprops.title ? graphprops.title : '',
            iconStyle: {
              color: 'none',
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      }
    };
  }, [props]);
  const getInitialState = useCallback(() => ({ option: getOption() }), [getOption]);

  const [option, setOption] = useState(() => getInitialState(props).option);
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      setOption(getInitialState(props).option);
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  const getData = async () => {
    let json = [];
    let series = [];
    requestCheck.current = false;
    setErrorInAPI(false);
    setNoDataInDB(false);

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    json =
      json &&
      Array.isArray(json) &&
      json.map((jsonData) => {
        return {
          name: jsonData.Name,
          value: jsonData.Value
        };
      });

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      const newOption = cloneDeep(option);
      if (json && Array.isArray(json) && json[0]) {
        series.push({
          type: 'gauge',
          startAngle: 90,
          endAngle: -270,
          center: ['50%', '50%'],
          radius: '80%',
          min: 0,
          max: 360,
          splitNumber: 8,
          axisLine: {
            lineStyle: {
              width: 18,
              color: [
                [0.25, '#a2aeb6'],
                [0.5, '#a2aeb6'],
                [0.75, '#a2aeb6'],
                [1, '#a2aeb6']
              ]
            }
          },
          axisTick: {
            show: false
          },
          pointer: {
            offsetCenter: [0, 0],
            icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
            length: '80%',
            itemStyle: {
              color: '#f50505 '
            }
          },
          axisLabel: {
            color: '#ffffff',
            fontSize: 20,
            distance: -50,
            rotate: 'circular',
            formatter: function (value) {
              if (value === 360) {
                return 'N';
              } else if (value === 90) {
                return 'E';
              } else if (value === 270) {
                return 'W';
              } else if (value === 180) {
                return 'S';
              }
              return '';
            }
          },
          title: {
            offsetCenter: [0, '-10%'],
            fontSize: 25
          },
          detail: {
            fontSize: 30,
            fontWeight: 'smoothConstraint',
            offsetCenter: [0, '10%'],
            valueAnimation: true,
            formatter: function (value) {
              return Math.round(value * 1) + ' °';
            },
            unit: {
              fontSize: 50,
              color: '#ffffff',
              offsetCenter: [0, '0%']
            },
            color: '#ffffff'
          },
          data: [json[0] && json[0] ? json[0].value : {}]
        });
      }

      newOption.series = series;
      setOption(newOption);
      setRefreshDateTime(moment());
    }

    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  return (

    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          id={Math.ceil(Math.random(100, 100000) * 1000)}
          option={option}
          style={{
            height: '90%',
            width: '100%'
          }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(CompassGuage);
